import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import axios from 'axios';
import React, { useEffect, useState } from 'react'

const ConfigureTime = () => {
    const [level2Time, setLevel2Time] = useState('1'); // Default value for Level 2 Time
  const [level3Time, setLevel3Time] = useState('3'); // Default value for Level 3 Time

  const handleLevel2TimeChange = (event) => {
    setLevel2Time(event.target.value);
  };

  const handleLevel3TimeChange = (event) => {
    setLevel3Time(event.target.value);
  };


  const fetchData = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.get(
        "https://jk-msfa-dev-api.jktyre.co.in/api/v1/query/EscalationMatrixTimeConfig",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setLevel2Time( response.data.data.level2);
      setLevel3Time(response.data.data.level3);
      //  setPreData(response.data.queries);
      
    } catch (error) {
        console.error("Error fetching data:", error);
      
    }
  };


  const updateData = async (dataToUpdate) => {
    try {
      const token = localStorage.getItem('token');
  
      const response = await axios.put(
        'https://jk-msfa-dev-api.jktyre.co.in/api/v1/query/EscalationMatrixTimeConfig', // Replace with your API endpoint
        dataToUpdate,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json', // Adjust content type if necessary
          },
        }
      );
  
      console.log('Data updated:', response.data);
      return response.data; // Return data if needed
    } catch (error) {
      console.error('Error updating data:', error);
      throw error; // Handle or rethrow the error as needed
    }
  };
  
  useEffect(() => {
  
      fetchData();
  }, [])
  

  const submit=()=>{
  const dataToUpdate={
    level1: "Immediately", 
    level2: level2Time, 
    level3: level3Time

  }
  updateData(dataToUpdate)
  setLevel3Time('')
  setLevel2Time('')
  fetchData();
  }
  return (
    <div>
      
      <Box p={2} maxWidth={400} >
      <Grid container mb={5} spacing={3} direction="column">
        <Grid  item>
          <Typography variant="body1" gutterBottom>
            Level 1 Time
          </Typography>
          <TextField disabled  value="Immediately" InputProps={{sx:{height:40}}} variant="outlined" fullWidth />
        </Grid>
        <Grid  item>
          <Typography variant="body1" gutterBottom>
          Level 2 Time (In Hours)
          </Typography>
          <TextField  InputProps={{sx:{height:40}}} value={level2Time} onChange={handleLevel2TimeChange} variant="outlined" fullWidth />
        </Grid>
        <Grid  item>
          <Typography variant="body1" gutterBottom>
          Level 3 Time (In Hours)
          </Typography>
          <TextField  InputProps={{sx:{height:40}}} value={level3Time} onChange={handleLevel3TimeChange} variant="outlined" fullWidth />
        </Grid>
      </Grid>
      <Grid container direction="row">
            <Button variant="contained" sx={{mr:3,backgroundColor:'#778899','&:hover': {
          backgroundColor: '#778899', // Keep the background color same as default
        },}} >Cancel</Button> 
            <Button variant="contained" onClick={submit}>Submit</Button>
        </Grid>
    </Box>
    </div>
  )
}

export default ConfigureTime
